export default __webpack_public_path__ + "static/media/image-chair-learn-w@3x.b0243478.webp";